export default {
  title: 'Beste keuze voor jou',
  match: 'Match: ',
};
